import React, { FunctionComponent } from "react"
import BadTicketPositiveResponsesTypes from "../../types/BadTicketPositiveResponsesTypes"
import PositiveResponseService from "../../utils/PositiveResponseService"
import { OverlayTrigger, Spinner } from "react-bootstrap"
import PositiveResponseCrudService from "../../utils/PositiveResponseCrudService"
import "./BadTicketPositiveResponsesListContextMenu.css"

interface Props {
    btpr: BadTicketPositiveResponsesTypes
}

const BadTicketPositiveResponsesListContextMenu: FunctionComponent<Props> = (props) => {

    const { addPositiveResponseRerun, ignorePositiveResponseErrors } = PositiveResponseCrudService
    const { state, positiveResponseTootlip } = PositiveResponseService
    const { busyId } = state
    const { btpr } = props
    const TicketPositiveResponseId = btpr.TicketPositiveResponseId

    return (
        <div
            id={`f508d09c-c1c3-468a-922f-714b3c85589e-${btpr.TicketPositiveResponseId}`}
            className="BadTicketPositiveResponsesListContextMenu"
            style={{ display: `${TicketPositiveResponseId === busyId ? "flex" : "none"}` }}
        >
            {busyId === -1 && <div className="BadTicketPositiveResponsesListContextMenuNotBusy">
                <OverlayTrigger placement="left" overlay={positiveResponseTootlip("Rerun")}>
                    <div className="BadTicketPositiveResponsesListContextMenuBtn BadTicketPositiveResponsesListContextMenuBtnResendBtn">
                        <span onClick={() => addPositiveResponseRerun([btpr.TicketPositiveResponseId])} className="material-icons">send</span>
                    </div>
                </OverlayTrigger>
                <OverlayTrigger placement="left" overlay={positiveResponseTootlip("Ignore")}>
                    <div className="BadTicketPositiveResponsesListContextMenuBtn BadTicketPositiveResponsesListContextMenuBtnIgnoreBtn">
                        <span onClick={() => ignorePositiveResponseErrors([btpr.TicketPositiveResponseId])} className="material-icons">block</span>
                    </div>
                </OverlayTrigger>
            </div>}
            {busyId === TicketPositiveResponseId && <Spinner id="bad-ticket-positive-response-context-menu-spinner" animation="border" />}
        </div>
    )
}

export default BadTicketPositiveResponsesListContextMenu